import { render, staticRenderFns } from "./fbpEligibilityConfig.vue?vue&type=template&id=4883a9e2&scoped=true"
import script from "./fbpEligibilityConfig.vue?vue&type=script&lang=js"
export * from "./fbpEligibilityConfig.vue?vue&type=script&lang=js"
import style0 from "./fbpEligibilityConfig.vue?vue&type=style&index=0&id=4883a9e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883a9e2",
  null
  
)

export default component.exports